import React from 'react';

class NotFound extends React.Component {
  render() {
    return (
      <div className="not-found">
        <h1>This code has Expired</h1>
        <p>Please ask reception / member of staff for a new code.</p>
      </div>
    );
  }
}

export default NotFound;